import { render } from "./SurvivorModal.vue?vue&type=template&id=25ed501c&scoped=true"
import script from "./SurvivorModal.vue?vue&type=script&lang=js"
export * from "./SurvivorModal.vue?vue&type=script&lang=js"

import "./SurvivorModal.vue?vue&type=style&index=0&id=25ed501c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ed501c"]])

export default __exports__